import { ConfigObj } from '../utils/'

const defaultOpts = {
  btn: 'View Job Description',
  message: 'Nothing to show'
}

/**
 * Initialize the script
 */
export default class JobPortal {
  constructor($el, opts) {
    this.$el = $el
    this.options = ConfigObj.merge(defaultOpts, opts)
    this.$jobItemGroup = undefined
    this.$jobItem = undefined
  }

  init() {
    setTimeout(this.checkIfRolesExist.bind(this), 700)
  }


  // Add ID for anchor tag link on Live role page
  addCategoryId() {
    this.$jobItemGroup.forEach($item => {
      $item.id = `${$item.innerText.toLowerCase().replace(' ', '-')}`
    })

  }

  // Scroll to ID with window location
  scrollToId() {
    const hash = window.location.hash
    if (!hash) return
    const $anchor = document.querySelector(`${hash}`)
    if ($anchor == null) return
    window.scrollTo(0, $anchor.offsetTop)
  }


  // Add Job Category
  createJobCategory() {

    const $groups = [...document.querySelectorAll('.whr-group')];

    $groups.forEach($group => {
      const $groupName = $group.innerText;
      const $groupRoles = [...$group.nextElementSibling.children];

      $groupRoles.forEach($role => {
        const $jobInfo = $role.querySelector('.whr-info')
        const $newEl = document.createElement('p')

        $newEl.className = 'whr-department'
        $newEl.innerHTML = $groupName
        $role.insertBefore($newEl, $jobInfo)
      })
    })

  }


  // Add View Job listing CTA
  createViewJobBtn() {
    this.$jobItem.forEach($item => {
      const $newEl = document.createElement('div')
      const $link = $item.querySelector('.whr-title a').href

      $newEl.className = 'whr-cta'
      $newEl.innerHTML = `<a class="ps-button" m-secondary href="${$link}" target="_blank">${this.options.btn}</a>`

      $item.appendChild($newEl)
    })
  }


  // Add this message in case no role available
  addMarkUp() {
    this.$el.innerHTML = `<p class="ps-job-category-list__message">${this.options.message}</p>`;
  }


  // if Roles exist then add view job listing cta and job category to the jobs listing
  // If not, show a message that no job is available
  checkIfRolesExist() {
    this.$jobItemGroup = [... this.$el.querySelectorAll('.whr-group')]
    this.$jobItem = [... this.$el.querySelectorAll('.whr-item')]

    if (this.$jobItemGroup.length > 0) {
      this.addCategoryId()
      this.createJobCategory()
      this.createViewJobBtn()
      this.scrollToId()
    } else {
      this.addMarkUp()
    }
  }

}



// WEBPACK FOOTER //
// ./js/modules/JobPortal.js